import React, { useEffect, useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

function mapStateToProps(state) {
  const {
    preAuth: { iframeUrl, status, serverIframeUrl, threeDSMethodData },
  } = state;

  return { iframeUrl, status, serverIframeUrl, threeDSMethodData };
}

function PreAuth(props) {
  const {
    dispatch,
    iframeUrl,
    onPay,
    serverIframeUrl,
    shouldUseDispatch,
    status,
    threeDSMethodData,
  } = props;

  const timer = React.useRef();
  const formEl = useRef(null);
  const serverFormEl = useRef(null);

  const [isServerIFrameLoad, setServerIFrameLoad] = useState(false);

  useEffect(() => {
    if (serverFormEl?.current) {
      serverFormEl.current.submit();
    } else if (formEl?.current) {
      formEl.current.submit();
    }

    if ((status.success || status.error) && !iframeUrl) {
      if (shouldUseDispatch) {
        dispatch(onPay());
      } else {
        onPay();
      }
    }
  }, [iframeUrl, serverIframeUrl, dispatch, status, onPay, isServerIFrameLoad, threeDSMethodData]);

  const handlePostMessage = useCallback(
    (e) => {
      if (e.data === 'THREE_DS_METHOD_COMPLETED') {
        clearTimeout(timer.current);
        if (shouldUseDispatch) {
          dispatch(onPay());
        } else {
          onPay();
        }
      }
      window.removeEventListener('message', handlePostMessage);
    },
    [dispatch, onPay]
  );

  const handleIframeLoad = useCallback(() => {
    if (timer.current) {
      return;
    }

    timer.current = setTimeout(() => {
      if (shouldUseDispatch) {
        dispatch(onPay());
      } else {
        onPay();
      }
    }, 10000);
    window.addEventListener('message', handlePostMessage);
  }, [dispatch, handlePostMessage, onPay]);

  const handleServerIframeLoad = () => {
    setServerIFrameLoad(true);
  };

  const renderServerIframe = () => {
    if (!serverIframeUrl || isServerIFrameLoad) {
      return null;
    }

    return (
      <>
        <form
          ref={serverFormEl}
          target="3dsServerIframe"
          method="POST"
          action={serverIframeUrl}
          style={{ display: 'none' }}
        />
        <iframe
          name="3dsServerIframe"
          title="preAuthServerIframe"
          onLoad={handleServerIframeLoad}
          style={{ display: 'none' }}
        />
      </>
    );
  };

  const renderIframe = () => {
    if (!iframeUrl) {
      return null;
    }

    return (
      <>
        <form
          ref={formEl}
          target="3dsIframe"
          method="POST"
          action={iframeUrl}
          style={{ display: 'none' }}
        >
          {threeDSMethodData && (
            <input type="hidden" name="threeDSMethodData" value={threeDSMethodData} />
          )}
        </form>
        <iframe
          name="3dsIframe"
          onLoad={handleIframeLoad}
          title="preAuthIframe"
          style={{ display: 'none' }}
        />
      </>
    );
  };

  return (
    <>
      {renderServerIframe()}
      {renderIframe()}
    </>
  );
}

PreAuth.defaultProps = {
  shouldUseDispatch: true,
};

PreAuth.propTypes = {
  iframeUrl: PropTypes.string,
  serverIframeUrl: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  onPay: PropTypes.func.isRequired,
  status: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)).isRequired,
  shouldUseDispatch: PropTypes.bool,
  threeDSMethodData: PropTypes.string,
};
export default connect(mapStateToProps)(React.memo(PreAuth));
